import React, { useRef } from "react";

const NewTimetableNote = ({ onSubmit, onCancel }) => {
	const noteRef = useRef();
	return (
		<form
			method="POST"
			onSubmit={e => {
				e.preventDefault();
				onSubmit({ note: noteRef.current.value });
				noteRef.current.value = "";
			}}
		>
			<div className="card">
				<div className="card-head">
					<header>Add New Note</header>
				</div>
				<div className="card-body">
					<div className="form-row">
						<div className="col-8">
							<input
								type="text"
								id="new-note"
								required
								name="new-note"
								ref={noteRef}
								className="form-control input-height"
								placeholder="enter note.."
							/>
						</div>

						<div className="col">
							<button
								type="submit"
								className="mdl-button mdl-button--raised mdl-js-ripple-effect m-t-5 btn-circle btn-success"
							>
								Add Note <i className="material-icons">keyboard_arrow_down</i>
							</button>
						</div>
						<div className="col">
							<button
								type="button"
								onClick={onCancel}
								className="mdl-button mdl-button--raised mdl-js-ripple-effect m-t-5 btn-circle"
							>
								Cancel <i className="material-icons text-danger">close</i>
							</button>
						</div>
					</div>
				</div>
			</div>
		</form>
	);
};
export default NewTimetableNote;
